import { render, staticRenderFns } from "./login-sso.vue?vue&type=template&id=4f28e3ea&scoped=true&lang=pug&"
import script from "./login-sso.vue?vue&type=script&lang=js&"
export * from "./login-sso.vue?vue&type=script&lang=js&"
import style0 from "./login-sso.vue?vue&type=style&index=0&id=4f28e3ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f28e3ea",
  null
  
)

export default component.exports